import { BaseUser, House, CsiteBase } from '@arpada/arp-lib-common-qupro';
export class OwnerExtendedData {
    public owner: BaseUser;
    public house: House;
    public csite: CsiteBase;
}
